import React from 'react';
import { MainContent } from '../../utilities/mainContent';
import TableData from '../../utilities/table';
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
  // Drawer,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuButtons } from '../../utilities/menuButton';
// import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { DialogBox } from '../../utilities/dialog';
import { Add } from '../users/add';
import EditIcon from '@mui/icons-material/Edit';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import SpotServices from '../../../service/spot';
import { DeleteContent } from '../../../hooks/utils';
import { usePerms } from '../../../hooks/usePerms';

const items = [
  {
    label: 'Edit Site',
    icon: <EditIcon fontSize='small' />,
  },
  {
    label: 'Delete Site',
    icon: <DeleteIcon fontSize='small' />,
  },
];

const itemsAdmin = [
  {
    label: 'Edit Site',
    icon: <EditIcon fontSize='small' />,
  },
];

const csvCol = [
  {
    key: 'name',
    label: 'Name',
  },

  {
    key: 'updatedAt',
    label: 'Updated at ',
  },
  {
    key: 'createdAt',
    label: 'Created at',
  },
];

export const SiteComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [setMobileOpens, setMobileOpenss] = React.useState(false);
  const [site, setSite] = React.useState(null);
  const [filtered, setFiltered] = React.useState(null);
  const [isDelete, setIsDelete] = React.useState(false);
  const entryRole = ['admin', 'superAdmin'];
  const entryRole2 = ['superAdmin'];
  const { role: admin } = usePerms('', entryRole);
  const { role } = usePerms('', entryRole2);

  const roleCheck = role ? items : itemsAdmin;
  const { data, isLoading } = useQuery({
    queryKey: ['spot_list'],
    queryFn: () => SpotServices.allSpots(),
  });

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = () => {
    setMobileOpenss(!setMobileOpens);
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 480,
    },

    {
      field: 'updatedAt',
      headerName: 'Updated at ',
      width: 250,
    },
    {
      field: 'createdAt',
      headerName: 'Created at',
      width: 250,
    },

    {
      field: '',
      headerName: '',
      width: 80,
      renderCell: (params) => {
        return (
          <Grid container justifyContent='flex-end'>
            <IconButton
              aria-controls={open ? 'fade-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              disabled={admin ? false : true}
            >
              <MoreVertIcon />
            </IconButton>
            <MenuButtons
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              items={roleCheck.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleMenuItem(item, params)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography variant='subtitle2'>{item.label}</Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            />
          </Grid>
        );
      },
    },
  ];

  const handleMenuItem = (item, params) => {
    if (item.label === 'Sites') {
      toggleDrawer();
      setAnchorEl(null);
    } else if (item.label === 'Edit Site') {
      // navigate('/inspection/edit');
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === 'Delete Site') {
      setAnchorEl(null);
      setIsDelete(true);
      // setSelectedData((prev) => ({
      //   ...prev,
      //   isSelected: true,
      //   rowId: params.id,
      // }));
    } else {
      return null;
    }
  };
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: SpotServices.spot,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['spot_list'] });
      setIsDelete(false);
    },
  });
  return (
    <>
      <MainContent
        csvData={data}
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        fileNameWithFilter={'Site list'}
        fileName={'Site list'}
        valueFrom='add_spot'
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || '';
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) => item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          );
          setFiltered(() => value);
        }}
        title='Site'
        items={
          <TableData
            cols={columns}
            rows={filtered || data}
            maxWidthMob='84vw'
            height='400px'
            isLoading={isLoading}
            onRowClick={({ row }) => setSite(() => row)}
          />
        }
        isBtnName={true}
        btnName={'Add'}
        onBtnNameClick={() => {
          setSite(() => null);
          setIsDialog(() => true);
        }}
      />
      <DialogBox
        handleClose={() => setIsDialog(() => false)}
        open={isDialog}
        title={<Typography variant='subtitle1 span'>Add Site</Typography>}
        content={
          <Add
            label_name='Site'
            handleClose={() => setIsDialog(() => false)}
            site={site}
            mutationFn={site ? SpotServices?.spot : SpotServices?.addSpot}
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(() => false)}
        open={isDelete}
        maxWidth='500px'
        title={
          <Typography variant='subtitle1' component='span'>
            Delete Site
          </Typography>
        }
        content={
          <DeleteContent
            title='Are you sure you want to delete this Site?'
            onCancel={() => setIsDelete(false)}
            onSubmit={() => {
              const id = site.id;
              const method = 'delete';
              mutate({ id, method });
            }}
          />
        }
      />
    </>
  );
};
